<template>
  <div class="project-logic-container">
    <el-scrollbar class="scrollbar-container">
      <p class="logic_title ml-100">逻辑设置</p>
      <p class="text-desc ml-100">
        仅在符合以下条件时<el-tooltip
          class="item"
          content="你可以使用某些题型（单选题、多选题、图片选择、评分组件、NPS组件、下拉选择）或外部参数设定一些条件"
          effect="dark"
          placement="top"
        >
          <i class="el-icon-question" /> </el-tooltip
        >，显示相应题目。运算优先级：并且>或者，示例：条件1 并且 条件2 或者 条件3 并且 条件4 =（ 条件1 并且
        条件2）或者（ 条件3 并且 条件4 ）
      </p>
      <div class="show-logic-container">
        <div v-if="!logicList.length" class="not-logic-container">
          <el-row>
            <el-col :offset="10" :span="5">
              <el-button type="text" @click="addLogicHandle">
                <i class="el-icon-circle-plus-outline" />
                <span class="label">添加逻辑</span>
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div v-else class="logic-list-container">
          <el-row align="middle" justify="center" type="flex">
            <el-col :offset="4" :span="10">
              <el-tag class="message-tag" effect="plain" :type="isSave">{{ saveMessage }}</el-tag>
            </el-col>
            <el-col :offset="6" :span="6">
              <el-button size="mini" icon="el-icon-plus" :loading="isLoading" type="primary" @click="addLogicHandle">
                <i class="" />
                <span class="label">添加逻辑</span>
              </el-button>
            </el-col>
          </el-row>
          <div class="flex-row divider_box">
            <div style="width: 100px"></div>
            <el-divider style="flex: 1" />
          </div>
          <!-- 一个逻辑组start -->
          <div v-for="(logicItem, index) in logicList" :key="logicItem.id" class="logic-list">
            <div class="logic-list-delete" @click="handleRemoveLogicItem(index)">
              <!-- 删除逻辑组 -->
              <i class="el-icon-delete" />
            </div>

            <div
              class="logic-list-group"
              v-for="(logicgroup, gIndex) in logicItem.conditionGroup"
              :key="logicItem.id + 'group' + gIndex"
            >
              <template>
                <div class="logic-list-group-relation" v-if="gIndex === 0">如果:</div>
                <el-select style="width: 90px" v-else v-model="logicgroup.relation">
                  <el-option label="并且" value="AND" />
                  <el-option label="或者" value="OR" />
                </el-select>
              </template>
              <!-- 条件组start -->
              <div class="logic-list-group-condition">
                <el-popover trigger="click" placement="bottom-end" width="50" popper-class="btns_more_popover">
                  <div class="btns_more_item fs12" @click="delLogicGroup(logicItem, index, gIndex)">删除</div>
                  <div class="btns_more" slot="reference"><i class="el-icon-more"></i></div>
                </el-popover>
                <el-row
                  v-for="(cItem, cIndex) in logicgroup.conditionList"
                  :key="cIndex"
                  :gutter="20"
                  align="middle"
                  class="mt5 condition-content"
                  justify="center"
                  type="flex"
                >
                  <el-col v-if="cIndex !== 0" :span="3" class="text-center">
                    <el-select v-model="cItem.relation">
                      <el-option label="并且" value="AND" />
                      <el-option label="或者" value="OR" />
                    </el-select>
                  </el-col>
                  <el-col :span="3">
                    <el-select v-model="cItem.type" @change="handleClearExpression(cItem)">
                      <el-option label="题目" value="_TITLE" />
                      <el-option label="外部参数" value="_PARAMETERS" />
                    </el-select>
                  </el-col>
                  <el-col :span="9">
                    <el-select
                      v-if="cItem.type === '_PARAMETERS'"
                      v-model="cItem.parameter"
                      placeholder="请选择参数"
                      style="width: 100%"
                      @change="handleParameterChange(cItem)"
                    >
                      <el-option
                        v-for="item in parameterChildList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>

                    <el-cascader
                      v-else
                      style="width: 100%"
                      v-model="cItem.formItemId"
                      :options="getConditionProjectItemList(logicItem)"
                      :filterable="true"
                      :show-all-levels="false"
                      :append-to-body="false"
                      placeholder="请选择题目"
                      @change="handleConditionChange(cItem, logicItem)"
                      :props="{
                        expandTrigger: 'hover',
                        emitPath: false
                      }"
                    >
                    </el-cascader>
                  </el-col>
                  <el-col :span="3">
                    <el-select v-model="cItem.expression" placeholder="请选择">
                      <el-option
                        v-for="item in getConditionOptions(cItem)"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-col>
                  <el-col :span="6">
                    <!--  下拉问题使用选项-->
                    <template v-if="cItem.type == '_TITLE'">
                      <el-select
                        style="width: 100%"
                        v-if="!['RATE', 'NPS'].includes(getFormItemIdType(cItem.formItemId))"
                        v-model="cItem.optionValue"
                        placeholder="请选择选项"
                      >
                        <el-option
                          v-for="item in getFormItemOptions(cItem.formItemId)"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                      <!--  评分使用数字框-->
                      <el-input-number v-else v-model="cItem.optionValue" :min="0" />
                    </template>
                    <!-- 外部参数使用输入框 -->
                    <template v-if="cItem.type === '_PARAMETERS'">
                      <el-input
                        v-if="getCurParameter(cItem.parameter).eleType === 'input'"
                        :placeholder="getCurParameter(cItem.parameter).placeholderText"
                        v-model="cItem.parameterValue"
                      />
                      <el-select
                        v-else
                        filterable
                        v-model="cItem.parameterSelectValue"
                        :placeholder="getCurParameter(cItem.parameter).placeholderText"
                        @change="(val) => parValueChange(val, cItem)"
                      >
                        <el-option
                          v-for="item in getCurParameter(cItem.parameter).options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </template>
                  </el-col>
                  <el-col :span="4" style="text-align: right">
                    <div class="btns">
                      <el-button type="text" @click="addConditionHandle(logicgroup, cItem, cIndex)">
                        <i class="el-icon-circle-plus-outline" />
                      </el-button>
                      <el-button
                        class="remove"
                        type="text"
                        @click="removeConditionHandle(logicItem, gIndex, cIndex, index)"
                      >
                        <i class="el-icon-remove-outline" />
                      </el-button>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="logic-list-group-add" @click="addConditionGroup(logicItem, gIndex)">
                <i class="el-icon-folder-add"></i> 添加条件组
              </div>
              <!-- 条件组end -->
            </div>
            <!-- 显示结果start -->
            <el-row
              class="logic-list-trigger"
              v-for="(trigger, tindex) in logicItem.triggerList"
              :key="`t1${tindex}`"
              align="middle"
              type="flex"
            >
              <!-- <el-col :span="3" class="text-center">
                
              </el-col> -->
              <span class="mr-10">则显示</span>
              <el-col :span="8">
                <el-cascader
                  v-model="trigger.formItemId"
                  :options="getTriggerItemList(logicItem)"
                  :filterable="true"
                  :show-all-levels="false"
                  :append-to-body="false"
                  placeholder="请选择问题"
                  :props="{
                    expandTrigger: 'hover',
                    emitPath: false
                  }"
                  style="width: 100%"
                >
                </el-cascader>
              </el-col>
              <el-col :span="3" class="text-center">
                <span>否则不显示</span>
              </el-col>
              <el-col :span="6">
                <el-button type="text" @click="addTriggerItemHandle(logicItem)">
                  <i class="el-icon-circle-plus-outline" />
                </el-button>
                <el-button
                  v-if="logicItem.triggerList.length > 1"
                  class="remove"
                  type="text"
                  @click="removeTriggerItemHandle(logicItem, index, tindex)"
                >
                  <i class="el-icon-remove-outline" />
                </el-button>
              </el-col>
            </el-row>
            <!-- 显示结果end -->
            <div class="flex-row divider_box">
              <div style="width: 100px"></div>
              <el-divider style="flex: 1" />
            </div>
          </div>
          <!-- 一个逻辑组end -->
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { jsonSimpleClone } from '@/utils'
import { getFormLogicRequest, listProjectItemRequest, saveFormLogicRequest } from '@/api/project/form'
import { debounce } from 'throttle-debounce'
import { conditionOptions, parameterOptions, parameterChildList } from './config'

export default {
  name: 'ProjectLogic',
  components: {},
  data() {
    return {
      saveMessage: '',
      isSave: 'info',
      isLoading: false,
      formKey: '',
      // 默认逻辑结构
      defaultLogicItem: {
        // 触发内容
        triggerList: [
          {
            formItemId: null,
            type: 'show'
          }
        ],
        // 逻辑条件
        conditionGroup: [
          {
            conditionList: [
              {
                // 条件类型:题目 _TITLE、外部参数_PARAMETERS
                type: '',
                // 问题
                formItemId: null,
                // 条件 == > < >= <=
                expression: null,
                // 值
                optionValue: null,
                // 关系
                relation: 'AND',
                // 外部参数
                parameter: 'product',
                //
                parameterValue: '',
                parameterSelectValue: ''
              }
            ],
            relation: 'AND'
          }
        ]
      },
      conditionOptions,
      parameterOptions,
      parameterChildList,
      allProjectItemList: [],
      logicList: []
    }
  },
  watch: {
    logicList: {
      handler(val) {
        console.log('logicList', val)
        if (val) {
          this.saveProjectLogic(val)
          this.isSave = 'info'
          this.saveMessage = '正在处理'
        }
      },
      deep: true
    }
  },
  mounted() {
    this.formKey = this.$route.query.key
    this.queryProjectItems()
    this.queryProjectLogic()
  },
  methods: {
    addConditionGroup(logicItem, gIndex) {
      const newLogicItem = jsonSimpleClone(this.defaultLogicItem.conditionGroup[0])
      logicItem.conditionGroup.splice(gIndex + 1, 0, newLogicItem)
    },
    // 删除条件组 如果逻辑组只有一个条件组，那么删除条件组 = 删除逻辑组
    delLogicGroup(logic, logicIdx, groupIndex) {
      console.log('logicItem', logic)
      const curItem = logic.conditionGroup
      if (curItem.length > 1) {
        curItem.splice(groupIndex, 1)
      } else {
        this.handleRemoveLogicItem(logicIdx)
      }
    },
    addConditionHandle(logicGroupItem, cItem, cIndex) {
      console.log('logicItem, cItem', logicGroupItem, cItem)

      logicGroupItem.conditionList.push({ relation: 'AND' })
    },
    // 删除条件
    removeConditionHandle(logic, groupIndex, curIndex, logicIndex) {
      const curItem = logic.conditionGroup[groupIndex]
      if (curItem.conditionList.length > 1) {
        curItem.conditionList.splice(curIndex, 1)
      } else {
        this.delLogicGroup(logic, logicIndex, groupIndex)
      }
    },
    addTriggerItemHandle(logicItem) {
      logicItem.triggerList.push({})
    },
    removeTriggerItemHandle(logicItem, logicIndex, index) {
      logicItem.triggerList.splice(index, 1)
    },
    addLogicHandle() {
      this.isLoading = true
      let newLogicItem = jsonSimpleClone(this.defaultLogicItem)
      newLogicItem.id = new Date().getTime()
      this.logicList.push(newLogicItem)
    },
    // 参数类型改变时 reset 逻辑条件
    handleClearExpression(cItem) {
      this.$set(cItem, 'expression', null)
      if (cItem.type === '_TITLE') {
        this.$set(cItem, 'parameter', 'product')
        this.$set(cItem, 'parameterSelectValue', '')
      } else {
        this.$set(cItem, 'formItemId', null)
      }
    },
    getItemByformItemId(formItemId) {
      const list = this.allProjectItemList
        .map((group) => {
          return group.items.find((item) => item.formItemId == formItemId)
        })
        .filter((item) => item !== undefined)
      return list.length > 0 ? list[0] : null
    },
    getConditionOptions(cItem) {
      const formItemId = cItem.formItemId
      let opts = []
      if (cItem.type == '_TITLE') {
        if (!formItemId) return []
        opts = this.getOptions(formItemId)
      } else {
        opts = jsonSimpleClone(this.parameterOptions)
      }
      return opts
    },
    getOptions(formItemId) {
      // 截取第一个数字前面的字符串
      let type = formItemId.replace(/(\D+)\d+.*/, '$1').toUpperCase()
      let conditionOptions = jsonSimpleClone(this.conditionOptions)
      if (type === 'RATE' || type === 'NPS') {
        // 移除前两个选项
        conditionOptions.splice(0, 1)
      } else {
        conditionOptions.splice(1, 4)
      }
      return conditionOptions
    },
    formatCascaderOptions(list, disabledList) {
      return list.map((group) => ({
        value: group.formItemGroupId, // 父节点使用 formItemGroupId
        label: group.name,
        children: group.items.map((item) => ({
          value: item.formItemId, // 子节点使用 id
          label: item.questionNumber ? `${item.questionNumber}.${item.textLabel}` : item.textLabel,
          disabled: (item.disabled = disabledList.includes(item.formItemId))
        }))
      }))
    },
    // 获取条件可选择问题
    getConditionProjectItemList(logicItem) {
      // 作为逻辑的结果显示问题不能作为条件问题·
      const list = jsonSimpleClone(this.allProjectItemList).map((group) => ({
        ...group,
        items: group.items.filter((item) =>
          ['RADIO', 'CHECKBOX', 'SELECT', 'IMAGE_SELECT', 'RATE', 'NPS'].includes(item.type)
        )
      }))

      const triggerList = logicItem.triggerList.map((item) => item.formItemId)

      return this.formatCascaderOptions(list, triggerList)
    },
    // 获取显示问题可选择问题
    getTriggerItemList(logicItem) {
      console.log('logicItem', logicItem.conditionGroup)
      // let selectedFormItemList = []
      // 作为逻辑条件的问题不能作为显示问题·
      let selectedFormItemList = logicItem.conditionGroup
        ? logicItem.conditionGroup.map((item) => item.conditionList.map((item) => item.formItemId))
        : []
      // 逻辑结果的题目不能重复选择
      logicItem.triggerList.map((item) => selectedFormItemList.push(item.formItemId))
      let projectItemList = jsonSimpleClone(this.allProjectItemList)

      return this.formatCascaderOptions(projectItemList, selectedFormItemList)
    },
    /**
     * 获取选择问题的选项
     * @param formItemId
     * @returns {*[]|*}
     */
    getFormItemOptions(formItemId) {
      const formItem = this.allProjectItemList
        .flatMap((group) => group.items) // 更简洁
        .find((item) => item.formItemId == formItemId)
      return formItem?.scheme?.config?.options || []
    },
    // 逻辑题目修改reset 条件、选项、显示项
    handleConditionChange(cItem, logicItem) {
      this.$set(cItem, 'optionValue', null)
      this.$set(cItem, 'expression', null)
    },
    // 获取当前外部参数配置项
    getCurParameter(val) {
      if (!val) return { eleType: 'input' }
      return this.parameterChildList.filter((param) => param.value === val)[0]
    },
    parValueChange(val, cItem) {
      const optionList = this.getCurParameter(cItem.parameter).options
      this.$set(cItem, 'parameterValue', optionList.filter((E) => E.value === val)[0].label)
    },
    // 外部参数类型修改
    handleParameterChange(cItem) {
      this.$set(cItem, 'parameterSelectValue', '')
    },
    handleRemoveLogicItem(index) {
      this.logicList.splice(index, 1)
    },
    getFormItemIdType(formItemId) {
      if (!formItemId) return ''
      return formItemId.replace(/(\D+)\d+.*/, '$1').toUpperCase()
    },
    // 查询项目逻辑数据
    queryProjectLogic() {
      getFormLogicRequest({ formKey: this.formKey }).then((res) => {
        if (res.data) {
          this.logicList = res.data.scheme ? res.data.scheme : []
        }
      })
    },
    //
    queryProjectItems() {
      listProjectItemRequest({ key: this.formKey }).then((res) => {
        this.allProjectItemList = res.data
          .map((group) => ({
            ...group,
            items: group.items?.filter((item) => item.type !== 'PAGINATION') || []
          }))
          .filter((group) => group.items.length > 0)
      })
    },
    saveProjectLogic: debounce(430, false, function (logicList) {
      let data = { formKey: this.formKey, scheme: logicList }
      saveFormLogicRequest(data).then((res) => {
        this.isLoading = false
        this.isSave = ''
        this.saveMessage = '已保存'
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.project-logic-container {
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;

  .scrollbar-container {
    width: 75%;
    height: 100%;
  }

  .header-row {
    width: 230px;
    margin-bottom: 20px;
  }

  .logic_title {
    font-size: 18px;
    height: 45px;
    line-height: 45px;
    color: #484848;
    text-align: left;
    margin-top: 20px;
  }
}

.text-desc {
  font-size: 14px;
  line-height: 20px;
  color: #9b9b9b;
  margin-bottom: 10px;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.not-logic-container {
  .el-icon-circle-plus-outline {
    font-size: 20px;
  }

  .label {
    font-size: 18px;
  }
}

.logic-list-container {
  .tips {
    font-size: 14px;
    color: #aaa;
  }

  .label {
    font-size: 15px;
  }

  .remove {
    color: #ff4949;
  }
  .divider_box {
    ::v-deep {
      .el-divider--horizontal {
        width: auto;
        flex: 1;
        margin: 24px 0 10px;
      }
    }
  }
  .logic-list {
    position: relative;

    .logic-list-delete {
      // position: absolute;
      // right: 20px;
      // top: -15px;
      color: #ff4d4f;
      cursor: pointer;
      text-align: right;
      margin-bottom: 8px;
    }
    .logic-list-group {
      display: flex;
      align-items: center;
      padding-bottom: 55px;
      position: relative;
      &-add {
        position: absolute;
        left: 100px;
        bottom: 15px;
        background: #eff1f7;
        padding: 4px 10px;
        border-radius: 20px;
        font-size: 12px;
        color: #6e7073;
      }
      &-relation {
        width: 90px;
        text-align: right;
      }
      &-condition {
        margin-left: 10px;
        flex: 1;
        background: #f2f7ff;
        padding: 15px 30px 15px 15px;
        position: relative;
        .btns_more {
          position: absolute;
          right: 2px;
          top: 0px;
          .el-icon-more {
            transform: rotate(90deg);
            color: #6e7073;
            font-size: 14px;
          }
        }
        .condition-content {
          &:not(:last-child) {
            margin-bottom: 8px;
          }
          .btns {
            display: inline-block;
            padding: 0 4px;
            button {
              padding: 2px 0;
            }
            // width: 100px;
            // margin-left: 100px;
          }
        }
      }
    }
    &-trigger {
      padding-left: 100px;
    }
  }
}

.show-logic-container {
  padding: 10px;
  min-width: 950px;
  background-color: #fff;
  height: 100%;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 24px;
}
</style>
